module.exports = __webpack_public_path__ + "static/media/geo.3c80c43b.png";